module.exports = __webpack_public_path__ + "static/media/crop-alt-rotate-left.55ff67f6.svg";